import { bulkConfirmRowsData, bulkInvoiceRowsData } from "../../types/types";
import { BulkOrderMapType } from "./BulkConfirm";

export const determineBulkStatus = (
  orderNumber: string,
  pass: string[],
  partial: string[],
  fail: string[],
  pending: string[],
  rejected: string[],
  invoiced: string[],
  row: bulkInvoiceRowsData | bulkConfirmRowsData,
  partiallyInvoiced?: string[],
  confirmPayloadField?: string
): string => {
  if (pass?.includes(orderNumber)) return confirmPayloadField ?? "Confirmed";
  if (rejected?.includes(orderNumber)) return "Cancelled";
  if (invoiced?.includes(orderNumber)) return "Invoiced";
  if (partial?.includes(orderNumber)) return "Partially Confirmed";
  if (fail?.includes(orderNumber)) return "Downloaded Fail";
  if (pending?.includes(orderNumber)) return "Loading";
  if (partiallyInvoiced?.includes(orderNumber)) return "Partially Invoiced";
  return row?.status;
};

const bulkStatus = ["Downloaded Fail", "Loading"];

export const renderBulkStatus = (status: string): boolean =>
  bulkStatus?.includes(status);

export type BulkStatus = {
  pass: string[]; // CONFIRMED
  partial: string[]; // PARTIALLY CONFIRMED
  fail: string[]; // FAILURE
  invoiced: string[]; // INVOICED
  rejected: string[]; // REJECTED
  settled: string[]; //  CONFIRMED + PARTIALLY CONFIRMED + FAILURE + INVOICED + REJECTED
  pending: string[]; // INPROGRESS
  partiallyInvoiced?: string[]; // PARTIALLY INVOICED
};

export const initialBulkStatusMap = {
  pass: [],
  partial: [],
  fail: [],
  settled: [],
  pending: [],
  rejected: [],
  invoiced: [],
  partiallyInvoiced: [],
};

export interface RenderBulkStatusProps {
  status: string;
  type: BulkType;
}

export type BulkType = "confirm" | "invoice";

export interface BulkProgressProps {
  bulkStatusMap: BulkOrderMapType;
  type: BulkType;
  showProgress: any;
  handleHideProgress: (type: string) => void;
  isBulkRejection?: boolean;
}

export const showProgressInitialState = {
  progress: false,
  fail: false,
};

export const progressBarSx = {
  backgroundColor: "#FFF9EF", 
  "& .MuiLinearProgress-bar": {
    backgroundColor: "#B27A10",
  },
  border: "0.5px solid #B27A10", 
  borderRadius: "6px",
};
